import { useEffect } from 'react';
import { ENV_MODE } from '../../constants';

const useClarity = () => {
    useEffect(() => {
        if (ENV_MODE === 'production') {
            // Create script with inline content for clarity
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.textContent = `
            (function(c,l,a,r,i,t,y){
				c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
				t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
				y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
			})(window, document, "clarity", "script", "g7woejiewh");
            `;

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }
    }, []);

};

export default useClarity;
